// skipcq: JS-W1028, JS-0128
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Container from '@mui/material/Container';
import BreweryProfileGrid from './BreweryProfileGrid';
import BreweryGroupBanner from './BreweryGroupBanner';
import BreweryBackButton from './BreweryBackButton';
import BreweryRecordsSection from './BreweryRecordsSection';
import BreweryBeersSection from './BreweryBeersSection';
import BreweryBeerSourcesSection from './BreweryBeerSourcesSection';
import BreweryBeerIngestionRunsSection from './BreweryBeerIngestionRunsSection';
import BreweryBeerDupesSection from './BreweryBeerDupesSection';
import BreweryClaimUsersSection from './BreweryClaimUsersSection';
import DetailsFormHandler from './overrideBrewery/detailsForm/DetailsFormHandler';
import TabPanel from '../../components/tabs/TabPanel';

/**
 * BreweryDetailsTabs
 * Renders the Details / Records tabs for a brewery.
 */
function BreweryDetailsTabs({
  brewery,
  override,
  overrideLoading,
  overrideLoadError,
  onRetryOverrideLoad,
  handleUpdate,
  handleBackNavigation,
  parentBreweryId,
  onSaveStateChange,
  value,
  onTabChange,
  detailsActionBar,
}) {
  const handleTabChange = useCallback(
    (event, newValue) => {
      if (onTabChange) {
        onTabChange(newValue);
      }
    },
    [onTabChange],
  );

  return (
    <Container maxWidth={false}>
      <Grid container spacing={2} sx={{
        p: 2
      }}>
        <Grid item xs={12} md={12}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              mb: 1
            }}>
            <BreweryBackButton handleBackNavigation={handleBackNavigation} />
          </Box>
          <Box
            sx={{
              // position: 'sticky',
              // top: 48,
              // zIndex: (theme) => theme.zIndex.appBar - 1,
              bgcolor: 'background.paper',
              borderBottom: '1px solid',
              borderColor: 'divider',
              mb: 2,
            }}
          >
            <Tabs
              value={value}
              onChange={handleTabChange}
              aria-label="Brewery management tabs"
            >
            <Tab
              id="simple-tab-0"
              aria-controls="simple-tabpanel-0"
              label="Details"
            />
            <Tab
              id="simple-tab-1"
              aria-controls="simple-tabpanel-1"
              label="Records"
            />
            <Tab
              id="simple-tab-2"
              aria-controls="simple-tabpanel-2"
              label="Beers"
            />
            <Tab
              id="simple-tab-3"
              aria-controls="simple-tabpanel-3"
              label="Sources"
            />
            <Tab
              id="simple-tab-4"
              aria-controls="simple-tabpanel-4"
              label="Ingestion Runs"
            />
            <Tab
              id="simple-tab-5"
              aria-controls="simple-tabpanel-5"
              label="Beer Dupes"
            />
            <Tab
              id="simple-tab-6"
              aria-controls="simple-tabpanel-6"
              label="Claimed/Users"
            />
          </Tabs>
          </Box>

          <TabPanel value={value} index={0} disableGutters>
            <BreweryGroupBanner breweryGroupId={brewery?.breweryGroupId} />
            {detailsActionBar}
            <Grid container spacing={2} sx={{
              p: 2
            }}>
              <Grid item xs={12} md={4}>
                <BreweryProfileGrid brewery={brewery} />
              </Grid>
              <Grid item xs={12} md={8}>
                <DetailsFormHandler
                  brewery={brewery}
                  override={override}
                  overrideLoading={overrideLoading}
                  overrideLoadError={overrideLoadError}
                  onRetryOverrideLoad={onRetryOverrideLoad}
                  handleUpdate={handleUpdate}
                  onSaveStateChange={onSaveStateChange}
                />
              </Grid>
            </Grid>
          </TabPanel>

          <TabPanel value={value} index={1} disableGutters>
            <BreweryRecordsSection
              parentBreweryId={parentBreweryId}
              breweryState={brewery?.state}
            />
          </TabPanel>

          <TabPanel value={value} index={2} disableGutters>
            <BreweryBeersSection
              parentBreweryId={parentBreweryId}
              breweryName={brewery?.name}
              breweryGroupId={brewery?.breweryGroupId}
            />
          </TabPanel>

          <TabPanel value={value} index={3} disableGutters>
            <BreweryBeerSourcesSection
              parentBreweryId={parentBreweryId}
              breweryName={brewery?.name}
              breweryCity={brewery?.city}
              breweryState={brewery?.state}
            />
          </TabPanel>

          <TabPanel value={value} index={4} disableGutters>
            <BreweryBeerIngestionRunsSection parentBreweryId={parentBreweryId} />
          </TabPanel>

          <TabPanel value={value} index={5} disableGutters>
            <BreweryBeerDupesSection parentBreweryId={parentBreweryId} />
          </TabPanel>

          <TabPanel value={value} index={6} disableGutters>
            <BreweryClaimUsersSection breweryId={parentBreweryId} />
          </TabPanel>
        </Grid>
      </Grid>
    </Container>
  );
}

BreweryDetailsTabs.propTypes = {
  brewery: PropTypes.object,
  override: PropTypes.object,
  overrideLoading: PropTypes.bool,
  overrideLoadError: PropTypes.object,
  onRetryOverrideLoad: PropTypes.func,
  handleUpdate: PropTypes.func.isRequired,
  handleBackNavigation: PropTypes.func.isRequired,
  parentBreweryId: PropTypes.string.isRequired,
  onSaveStateChange: PropTypes.func,
  value: PropTypes.number.isRequired,
  onTabChange: PropTypes.func,
  detailsActionBar: PropTypes.node,
};

BreweryDetailsTabs.defaultProps = {
  brewery: undefined,
  override: undefined,
  overrideLoading: false,
  overrideLoadError: null,
  onRetryOverrideLoad: undefined,
  onSaveStateChange: undefined,
  onTabChange: undefined,
  detailsActionBar: null,
};

export default BreweryDetailsTabs;


